<div class="container-fluid py-5">
    <div class="col-md-8 cah-signup-card offset-0 offset-md-2 offset-lg-2 offset-md-0  mt-0 mt-lg-5">
        <div class="d-flex">
            <div class="cah-signup-sec px-0 shadow d-lg-block d-none d-sm-none" style="font-family: 'Roboto',sans-serif !important">
                <div class="py-5 cah-p-lr-40 text-white">
                    <h1 class="fw-bolder cah-font-35 mb-4">Specialist <br>Sign Up</h1>
                    <p class="cah-font-16 mb-5" *ngIf="step == 1">Sign Up with your details to get started</p>
                    <p class="cah-font-16 mb-5" *ngIf="step == 2">Set Password</p>
                    <div class="text-center py-5"><img src="{{assets}}img/auth/speci-graphic-left.png"></div>
                </div>
            </div>
            <div class="w-100 px-0">
                <form [formGroup]="signupFormGroup" autocomplete="doNotAutoComplete"
                >
                    <div class="w-100 cah-sign-up-step" [class.d-block]="step == 1">
                        <div class="pt-5 px-5">
                            <h1 class="cah-m-b-30 fw-bolder text-center text-violet d-block d-lg-none">Specialist Sign Up</h1>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Enter Credentials</mat-label>
                                    <input 
                                    required
                                    formControlName="credentials" 
                                    autocomplete="doNotAutoComplete"
                                    matInput 
                                    appTrim
                                    appAutocapitalizeall>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['credentials'].hasError('required')  && signupFormGroup.controls['credentials'].touched">{{message.error[5]}}</div>
                                    <!-- <div class="mat-error error-message" *ngIf="signupFormGroup.controls['credentials'].hasError('pattern')  && signupFormGroup.controls['credentials'].touched">{{message.error[6]}}</div> -->
                                    <!-- <div class="mat-error error-message" *ngIf="signupFormGroup.controls['credentials'].hasError('whitespace')  && signupFormGroup.controls['credentials'].touched">{{message.error[6]}}</div> -->
                                  </div>
                            </div>
                            <!-- <input id="txtSearchPlaces" type="text" size="50" placeholder="Anything you want!"> -->

                            <div class="field-content">
                                
                                <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Enter First Name</mat-label>
                                <input 
                                formControlName="firstName" 
                                matInput 
                                required
                                autocomplete="doNotAutoComplete"
                                maxlength="50" 
                                appTrim
                                appInputTitleCase>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['firstName'].hasError('required')  && signupFormGroup.controls['firstName'].touched">{{message.error[1]}}</div>
                                    <div class="mat-error error-message" *ngIf="!signupFormGroup.controls['firstName'].hasError('required') && signupFormGroup.controls['firstName'].value.trim().length == 0  && signupFormGroup.controls['firstName'].touched">{{message.error[2]}}</div>

                                    <!-- <div class="mat-error error-message" *ngIf="signupFormGroup.controls['firstName'].hasError('pattern')  && signupFormGroup.controls['firstName'].touched">{{message.error[2]}}</div> -->
                                    <!-- <div class="mat-error error-message" *ngIf="signupFormGroup.controls['firstName'].hasError('whitespace')  && signupFormGroup.controls['firstName'].touched">{{message.error[2]}}</div> -->
                                  </div>
                            </div>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Enter Last Name</mat-label>
                                <input 
                                formControlName="lastName" 
                                matInput
                                required
                                autocomplete="doNotAutoComplete"
                                maxlength="50" 
                                appTrim
                                appInputTitleCase>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['lastName'].hasError('required') && signupFormGroup.controls['lastName'].touched">{{message.error[3]}}</div>
                                    <div class="mat-error error-message" *ngIf="!signupFormGroup.controls['lastName'].hasError('required') && signupFormGroup.controls['lastName'].value.trim().length == 0  && signupFormGroup.controls['lastName'].touched">{{message.error[4]}}</div>

                                    <!-- <div class="mat-error error-message" *ngIf="signupFormGroup.controls['lastName'].hasError('pattern') && signupFormGroup.controls['lastName'].touched">{{message.error[4]}}</div> -->
                                    <!-- <div class="mat-error error-message" *ngIf="signupFormGroup.controls['lastName'].hasError('whitespace') && signupFormGroup.controls['lastName'].touched">{{message.error[4]}}</div> -->
                                  </div>
                            </div>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Enter Specialty</mat-label>
                                    <mat-select required [formControl]="specialityMultiCtrl" (selectionChange)="specialityChange($event.value)" [multiple]="true" #multiSelect>
                                        <mat-option>
                                            <ngx-mat-select-search [showToggleAllCheckbox]="true" placeholderLabel="Find specialty..."
                                                 noEntriesFoundLabel="'no matching speciality found'"
                                                [toggleAllCheckboxIndeterminate]="specialityMultiCtrl.value.length > 0 && specialityMultiCtrl.value.length < allSpecialitySize"
                                                [toggleAllCheckboxChecked]="specialityMultiCtrl.value.length === allSpecialitySize"
                                                (toggleAll)="toggleSelectAll($event)" [formControl]="specialityMultiFilterCtrl">
                                            </ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let speciality of filteredSpecialitiesMulti | async" [value]="speciality">
                                            {{ (speciality) | specialtyDisplay }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <mat-error *ngIf="specialityMultiCtrl.invalid && specialityMultiCtrl.touched">Please select your specialty.</mat-error>
                
                                </div>
                            </div>
                            <div class="field-content" *ngIf="specialityMultiCtrl.value.length > 0 && specialityMultiCtrl.value.includes('Other')">
                                <mat-form-field appearance="outline" class="w-100">
                               <mat-label>Enter Other Specialty</mat-label>
                               <input [formControl]="otherSpeciality" matInput appInputTitleCase appTrim>
                               </mat-form-field>
                               <div class="mat--error message-block">
                                <mat-error *ngIf="otherSpeciality.invalid">Please enter valid specialty.</mat-error>
                            </div>
                           </div>
                            <div class="field-content">
                                <!-- <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Enter Education</mat-label>
                                <input formControlName="education" matInput appInputTitleCase>
                                </mat-form-field> -->
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Enter Education</mat-label> 
                                    <mat-select required [formControl]="education" (selectionChange)="educationChange($event.value)" multiple>
                                      <mat-select-trigger>
                                        {{education?.value ? education.value?.[0] : ''}}
                                        <span *ngIf="(education?.value?.length || 0) > 1" class="example-additional-selection">
                                          (+{{(education?.value?.length || 0) - 1}} {{education?.value?.length === 2 ? 'other' : 'others'}})
                                        </span>
                                      </mat-select-trigger>
                                      <mat-option 
                                      *ngFor="let educations of educationsList"
            
                                       [value]="educations">{{educations}}</mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                  <div class="mat--error message-block">
                                    <mat-error *ngIf="education.invalid && education.touched">{{message.error[7]}}</mat-error>
                                </div>
                                <!-- <div class="mat--error message-block">
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['education'].hasError('required') && signupFormGroup.controls['education'].touched">{{message.error[7]}}</div>
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['education'].hasError('pattern') && signupFormGroup.controls['education'].touched">{{message.error[8]}}</div>
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['education'].hasError('whitespace') && signupFormGroup.controls['education'].touched">{{message.error[8]}}</div>
                                  </div> -->
                            </div>
                            <div class="field-content" *ngIf="!isEducationOther">
                                 <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Enter Other Education</mat-label>
                                <input [formControl]="otherEducation" matInput appInputTitleCase appTrim>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <mat-error *ngIf="otherEducation.invalid">{{message.error[8]}}</mat-error>
                                </div>
                            </div>
                            
                            <!-- <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Search Practice Address</mat-label>
                                <input id="txtSearchPlaces"
                                name="txtSearchPlaces"
                                [formControl]="address"
                                autocomplete="doNotAutoComplete"
                                matInput 
                                maxlength="250" 
                                >
                                </mat-form-field>
                            </div> -->
                            <!-- <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Enter Practice Address</mat-label>
                                <input 
                                autocomplete="doNotAutoComplete"
                                formControlName="practiceAddress" 
                                matInput 
                                maxlength="250" 
                                >
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['practiceAddress'].hasError('required') && signupFormGroup.controls['practiceAddress'].touched">{{message.error[19]}}</div>
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['practiceAddress'].hasError('pattern') && signupFormGroup.controls['practiceAddress'].touched">{{message.error[20]}}</div>
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['practiceAddress'].hasError('whitespace') && signupFormGroup.controls['practiceAddress'].touched">{{message.error[20]}}</div>
                                  </div>
                            </div> -->
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Country</mat-label>
                                    <mat-select 
                                    formControlName="country" 
                                    (selectionChange)= "setStateValue($event)"
                                    required>
                                      <mat-option 
                                      *ngFor="let country of countries" 
                                      [value]="country">
                                      {{country}}
                                    </mat-option>
                                    </mat-select>
                                  </mat-form-field>
                                  
                                  <div class="mat--error message-block">
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['country'].hasError('required') && signupFormGroup.controls['country'].touched">{{message.error[67]}}</div>
                                  </div>
                            </div>
                            <div *ngIf=" this.signupFormGroup.value.country == 'Other' " class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Other Country</mat-label>
                                    <input 
                                    formControlName="otherCountry" 
                                    matInput 
                                    appInputTitleCase appTrim>
                                    </mat-form-field>
                                <div class="mat--error message-block">
                                     <div class="mat-error error-message" *ngIf="signupFormGroup.controls['otherCountry'].hasError('required') && signupFormGroup.controls['otherCountry'].touched">{{message.error[67]}}</div>
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['otherCountry'].hasError('pattern') && signupFormGroup.controls['otherCountry'].touched">{{message.error[67]}}</div>                                  </div>
                            </div>
                            <div 
                            *ngIf=" this.signupFormGroup.value.country !== 'Other' "
                            class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>License State/Territory</mat-label>
                                    <mat-select 
                                    required 

                                    (selectionChange)= "checkOtherOption($event)"
                                    formControlName="licenseState" >
                                        <mat-option
                                        *ngFor="let state of statesList" 
                                        [value]="state">
                                        {{state}}
                                      </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['country'].hasError('required')  && signupFormGroup.controls['licenseState'].touched">Please select your country first.</div>
                                    <div class="mat-error error-message" *ngIf="!signupFormGroup.controls['country'].hasError('required') && signupFormGroup.controls['licenseState'].hasError('required') && signupFormGroup.controls['licenseState'].touched">{{message.error[40]}}</div>
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['licenseState'].hasError('pattern') && signupFormGroup.controls['licenseState'].touched">{{message.error[41]}}</div>
                                  </div>
                            </div>
                            <div *ngIf=" this.signupFormGroup.value.licenseState == 'Other' || this.signupFormGroup.value.country == 'Other' " class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Other License State/Territory</mat-label>
                                    <input 
                                    formControlName="otherLicenseState" 
                                    matInput 
                                    appInputTitleCase appTrim>
                                    </mat-form-field>
                                <div class="mat--error message-block">
                                     <div class="mat-error error-message" *ngIf="signupFormGroup.controls['otherLicenseState'].hasError('required') && signupFormGroup.controls['otherLicenseState'].touched">{{message.error[82]}}</div>
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['otherLicenseState'].hasError('pattern') && signupFormGroup.controls['otherLicenseState'].touched">{{message.error[62]}}</div>                                  </div>
                            </div>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Enter License Number</mat-label>
                                <input 
                                maxlength="16" 
                                required
                                autocomplete="doNotAutoComplete"
                                (keyup)="checkLicenseNumber()"
                                formControlName="licenseNumber" 
                                appAutocapitalizeall
                                matInput appTrim>
                                <mat-icon class="material-icons-outlined" (click)="tooltip.toggle()" #tooltip="matTooltip" matSuffix matTooltip='If you are licensed in more than one state/ territory, you only need to list one license. This is for verification purposes only. If you would like to list additional licenses or states of practice, you may do so in the "about me" section of your profile.'>info</mat-icon>
                                </mat-form-field>
                                <div class="mat--error message-block">   
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['licenseNumber'].hasError('required') && signupFormGroup.controls['licenseNumber'].touched">{{message.error[11]}}</div>
                                    <!-- <div class="mat-error error-message" *ngIf="signupFormGroup.controls['licenseNumber'].hasError('minlength') && signupFormGroup.controls['licenseNumber'].touched">{{message.error[12]}}</div> -->
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['licenseNumber'].hasError('isLicenseNumberExist')">{{message.error[22]}}</div>
                                  </div>
                            </div>
                            <div class="field-content">
                                
                               
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>License Expiration Date</mat-label>
                                    <input 
                                    matInput 
                                    required
                                    [min]="minDate"
                                    [matDatepicker]="picker1" 
                                    (focus)="picker1.open()" 
                                   
                                    name="licenseExpiryDate" 
                                    [formControl]="licenseExpiryDate">
           <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
           <mat-datepicker #picker1></mat-datepicker>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <!-- <mat-error *ngIf="licenseValidityFlag == false && licenseExpiryDate.invalid">License expired.</mat-error> -->
                                    <!-- <mat-error *ngIf="licenseValidityFlag && licenseExpiryDate.invalid && licenseExpiryDate.touched">{{message.error[44]}}</mat-error> -->
                                    <mat-error *ngIf="licenseExpiryDate.invalid && licenseExpiryDate.touched">{{message.error[44]}}</mat-error>

                                </div>
                            
                        </div>

                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Enter Email Address</mat-label>
                                <input 
                                autocomplete="doNotAutoComplete"
                                maxlength="60" 
                                required
                                (keyup)="checkEmail()"
                                formControlName="email" 
                                appTrim
                                matInput>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['email'].hasError('required') && signupFormGroup.controls['email'].touched">{{message.error[13]}}</div>
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['email'].hasError('pattern') && signupFormGroup.controls['email'].touched">{{message.error[14]}}</div>
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['email'].hasError('isEmailExist')">{{message.error[21]}}</div>
                                  </div>
                            </div>
                            
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Liability Insurance Provider</mat-label>
                                    <input 
                                    required 
                                    appInputTitleCase
                                    formControlName="liabilityInsuranceProvider"
                                    appTrim
                                    matInput>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <div class="mat-error error-message" *ngIf="signupFormGroup.controls['liabilityInsuranceProvider'].hasError('required') && signupFormGroup.controls['liabilityInsuranceProvider'].touched">{{message.error[63]}}</div>
                                  </div>
                            </div>
                            <div class="field-content">
                                <mat-form-field appearance="outline" class="w-100">
                                    <mat-label>Expiration Date of Liability Insurance</mat-label>
                                    <input 
                                    matInput 
                                    required 
                                    [matDatepicker]="picker" 
                                    (focus)="picker.open()" 
                                    [min]="minDate"
                                    [formControl]="malpracticeInsuranceExpiryDate"
                                    name="malpracticeInsuranceExpiryDate">
                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-datepicker #picker></mat-datepicker>
                                </mat-form-field>
                                <div class="mat--error message-block">
                                    <mat-error *ngIf="malpracticeInsuranceExpiryDate.invalid && malpracticeInsuranceExpiryDate.touched">{{message.error[45]}}</mat-error>
                                </div>
                            </div>
                            <div class="pt-2" *ngIf="!showDocPreview">
                                <label 
                                style="cursor: pointer;"
                                for="cah-document-upload" 
                                class="col-lg-12 col-md-12 col-sm-12 col-xs-12 cah-drop-area mb-4" >
                                        <div class="text-center">
                                            <span class="material-icons text-violet cah-font-70">cloud_upload</span>
                                            <p class="text-violet cah-fw-500 pt-3">Upload Image Driving License/Other State Issued ID</p>
                                        </div>
                                </label>
                                <input 
                                type="file" 
                                name="driving_license" 
                                id="cah-document-upload" 
                                class="visually-hidden"  
                                (change)="readImage($event);"
                                accept="image/*">
                                <mat-error *ngIf="imageUploadError">{{imageUploadError}}</mat-error>

                            </div>
                            <div class="row pt-2" *ngIf="showDocPreview">
                                <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12 col-12 mb-3">
                                    <div class="cah-document-wraper">
                                        <div class="d-flex justify-content-end me-2">
                                            <div class="cah-edit-bg d-flex align-items-center justify-content-center me-5">
                                                <label for="cah-edit-document-upload" class=" d-flex align-items-center justify-content-center">
                                                    <span style="cursor: pointer;" class="material-icons-outlined text-white cah-font-20">edit</span>
                                                </label>
                                                <input 
                                                type="file" 
                                                name="edit_driving_license" 
                                                id="cah-edit-document-upload" 
                                                (change)="readImage($event);"
                                                class="visually-hidden">
                                            </div>
                                            <div class="cah-remove-bg d-flex align-items-center justify-content-center">
                                                <span 
                                                style="cursor: pointer;" 
                                                class="material-icons text-white cah-font-18" 
                                                (click)="deleteFile()">delete</span>
                                            </div>
                                        </div>
                                        <div class="border border-bottom-0 cah-document-img-wrap mb-0">
                                            <img [src]="imageSrc" class="img-fluid w-100">
                                        </div>
                                        <div class="cah-id-bottom">
                                            <p class="cah-fw-500 py-3 py-lg-3 py-sm-3 py-md-3 py-xs-3 mb-0">{{fileName}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="px-5">
                            <button 
                            type="button" 
                            [disabled]="!this.signupFormGroup.valid || !specialityMultiCtrl.valid || !licenseExpiryDate.valid || !malpracticeInsuranceExpiryDate.valid || !education.valid || !otherSpeciality.valid ||  !otherEducation.valid || signupFormGroup.controls['firstName'].value.trim().length == 0 || signupFormGroup.controls['lastName'].value.trim().length == 0"
                            class="btn btn-violet btn-lg w-100 fs-5 h-60 mt-2" 
                            (click)="submitForm()">Sign Up</button>
                            <div class="text-center mt-4 pb-5">
                                <span class="text-gray cah-font-16">Already have an account?</span><a class="create-acc-link text-violet text-decoration-none ms-1 cah-font-16" routerLink="../specialist-signin">Sign In</a>
                            </div>
                        </div>
                    </div>
                  
                </form>
                <form [formGroup]="passwordFormGroup" >
                <div class="w-100 cah-sign-up-step" [class.d-block]="step == 2">
                    <div class="pt-5 px-5">
                        <div class="field-content">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Enter Password</mat-label>
                                <input 
                                (keyup)="checkPassword()" 
                                formControlName="password" 
                                maxlength="16"
                                matInput 
                            
                                autocomplete="on"
                                required
                                [type]="hide ? 'password' : 'text'">
                                <button  mat-icon-button matSuffix matTooltip="Toggle Visibility" type="button" (click)="hide = !hide">
                                    <mat-icon *ngIf="!hide">visibility</mat-icon>
                                    <mat-icon *ngIf="hide">visibility_off</mat-icon>
                                  </button> 
                            </mat-form-field>
                            <div class="mat--error message-block">
                                <div class="mat-error error-message" *ngIf="passwordFormGroup.controls['password'].hasError('required') && passwordFormGroup.controls['password'].touched">{{message.error[17]}}</div>
                                <div class="mat-error error-message" *ngIf="passwordFormGroup.controls['password'].hasError('pattern') && passwordFormGroup.controls['password'].touched">{{message.error[18]}}</div>
                                <div class="mat-error error-message" *ngIf="passwordFormGroup.controls['password'].hasError('whitespace') && passwordFormGroup.controls['password'].touched">{{message.error[18]}}</div>
                              </div>  
                        </div>
                        <div class="field-content">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Confirm Password</mat-label>
                                <input 
                                formControlName="confirmPassword"
                                maxlength="16"
                                 matInput 
                                 required
                                 autocomplete="on"
                                 [type]="chide ? 'password' : 'text'" >
                                 <button  mat-icon-button matSuffix matTooltip="Toggle Visibility" type="button" (click)="chide = !chide">
                                    <mat-icon *ngIf="!chide">visibility</mat-icon>
                                        <mat-icon *ngIf="chide">visibility_off</mat-icon>
                                  </button> 
                            </mat-form-field>
                            <div class="mat--error">
                                <div class="mat-error" *ngIf="passwordFormGroup.controls['confirmPassword'].hasError('passwordCompare')">{{message.error[16]}}</div> 
                             </div>
                        </div>
                        <div class="mb-4">
                            <div>
                                <mat-checkbox 
                                #lowerCase 
                                [disabled]= true
                                class="example-margin"  
                                color="Primary">Atleast 1 lower case character
                            </mat-checkbox>
                            </div>
                            <div>
                                <mat-checkbox 
                                #upperCase 
                                [disabled]= true
                                class="example-margin"  
                                color="Primary">Atleast 1 upper case character</mat-checkbox>
                            </div>
                            <div>
                                <mat-checkbox
                                 #oneNumeric 
                                 [disabled]= true
                                 class="example-margin"  
                                 color="Primary">Atleast 1 numeric character</mat-checkbox>
                            </div>
                            <div>
                                <mat-checkbox 
                                #symbol
                                [disabled]= true
                                class="example-margin" 
                                color="Primary">Atleast 1 symbol</mat-checkbox>
                            </div>
                            <div>
                                <mat-checkbox 
                                #minLength 
                                [disabled]= true
                                class="example-margin" 
                                color="Primary">Minimum 8 characters long</mat-checkbox>
                            </div>
                        </div>
                    </div>
                    <div class="px-5 mb-3 mb-lg-5 mb-md-5 text-center">
                        <button 
                        (click)="openTermsAndDocument()"
                        [disabled]="!this.passwordFormGroup.valid"
                         class="btn btn-violet btn-lg w-100 fs-5 h-60 mt-2">
                         Next
                        </button>
                        <!-- <a class="create-acc-link text-violet text-decoration-none font-18 py-3 d-block" (click)="step = 1">Back</a> -->
                    </div>
                </div>
            </form>
            </div>
        </div>
    </div>
</div>